import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedMod } from "../../Redux/actions/settingsActions";
import CommonSetting from "../CommonSetting/CommonSetting";
import UserDropdown from "./Components/UserDropdown";
import { logoutUser } from "../../Redux/slice/features/authSlice";

const CommonHeader = ({ toggleSidebar }) => {
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedMode, setSelectedMode] = useState("light");

  const setThemeMode = (mode) => {
    setSelectedMode(mode);
  };

  const handleLogout = async () => {
    const isEmployee = sessionStorage.getItem("hrmsLogin");
    const isHrmsPath = window.location.pathname.startsWith("/hrms");

    // Clear session and Redux state first
    sessionStorage.removeItem("hrmsLogin");
    await dispatch(logoutUser());

    // Redirect based on user type/path
    if (isEmployee || isHrmsPath) {
      navigate("/hrms/login", { replace: true });
    } else {
      navigate("/signin", { replace: true });
    }
  };

  let iconId;
  switch (selectedMode) {
    case "light":
      iconId = "sun-fill";
      break;
    case "dark":
      iconId = "moon-stars-fill";
      break;
    case "auto":
      iconId = "circle-half";
      break;
    default:
      iconId = "sun-fill";
  }

  useEffect(() => {
    dispatch(setSelectedMod(selectedMode));
  }, [selectedMode]);

  return (
    <>
      <header
        className="px-xl-5 px-lg-4 px-3 sticky-top"
        id="headerDark"
        data-bs-theme="none"
      >
        <div className="d-flex justify-content-between align-items-center py-2 w-100">
          <div className="d-flex align-items-center pe-4">
            <button
              className="btn d-inline-flex d-xl-none border-0 p-0 pe-2"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvas_Navbar"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="svg-stroke"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3" />
                <path
                  d="M21 6v12a3 3 0 0 1 -6 0v-12a3 3 0 0 1 6 0z"
                  fill="var(--accent-color)"
                />
                <path d="M15 12h-8" />
                <path d="M10 9l-3 3l3 3" />
              </svg>
            </button>
            <button
              className="btn d-xl-inline-flex d-none border-0 p-0 pe-2 sidebar-toggle-btn"
              type="button"
              onClick={toggleSidebar}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="svg-stroke"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3" />
                <path
                  d="M21 6v12a3 3 0 0 1 -6 0v-12a3 3 0 0 1 6 0z"
                  fill="var(--accent-color)"
                />
                <path d="M15 12h-8" />
                <path d="M10 9l-3 3l3 3" />
              </svg>
            </button>
            {/* <!--[ Start:: Brand Logo icon ]--> */}
            <Link
              to="/"
              className="brand-icon text-decoration-none d-flex align-items-center"
              title="JTDCL Admin Template"
            >
              <span className="fw-bold ps-2 fs-3 d-none d-xl-inline-flex text-gradient">
                Jharkhand Tourism Development Corporation Ltd.

              </span>
            </Link>
          </div>
          {/* <form className="d-none d-md-flex">
            <div className="main-search">
              <svg
                className="search-icon svg-stroke"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                <path d="M21 21l-6 -6" />
              </svg>
              <input
                type="search"
                className="form-control"
                placeholder="Search..."
              />
            </div>
          </form> */}
          <ul className="header-menu flex-grow-1">
            {/* <!--[ Start:: notification ]--> */}

            {/* <!--[ Start:: language ]--> */}

            {/* <!--[ Start:: theme light/dark ]--> */}
            {/* <li className="nav-item dropdown px-md-1">
              <a
                className="dropdown-toggle gray-6"
                href="#"
                id="bd-theme"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <svg
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  className="theme-icon-active"
                >
                  <use href={`#${iconId}`}></use>
                </svg>
              </a>
              <ul
                className="dropdown-menu dropdown-menu-end p-2 p-xl-3 shadow rounded-4"
                aria-labelledby="bd-theme"
              >
                <li className="mb-1">
                  <a
                    className={`dropdown-item rounded-pill ${
                      selectedMode === "light" ? "active" : ""
                    }`}
                    href="#"
                    data-bs-theme-value="light"
                    onClick={() => setThemeMode("light")}
                  >
                    <svg
                      className="avatar xs me-2 opacity-50 theme-icon"
                      fill="currentColor"
                    >
                      <use href="#sun-fill"></use>
                    </svg>{" "}
                    Light
                  </a>
                </li>
                <li className="mb-1">
                  <a
                    className={`dropdown-item rounded-pill ${
                      selectedMode === "dark" ? "active" : ""
                    }`}
                    href="#"
                    data-bs-theme-value="dark"
                    onClick={() => setThemeMode("dark")}
                  >
                    <svg
                      className="avatar xs me-2 opacity-50 theme-icon"
                      fill="currentColor"
                    >
                      <use href="#moon-stars-fill"></use>
                    </svg>{" "}
                    Dark
                  </a>
                </li>
                <li className="mb-1">
                  <a
                    className={`dropdown-item rounded-pill ${
                      selectedMode === "auto" ? "active" : ""
                    }`}
                    href="#"
                    data-bs-theme-value="auto"
                    onClick={() => setThemeMode("auto")}
                  >
                    <svg
                      className="avatar xs me-2 opacity-50 theme-icon"
                      fill="currentColor"
                    >
                      <use href="#circle-half"></use>
                    </svg>{" "}
                    Auto
                  </a>
                </li>
              </ul>
            </li> */}
            {/* <!--[ Start:: theme setting ]--> */}

            <li className="nav-item py-2 py-md-1 col-auto">
              <div className="vr d-none d-sm-flex h-100 mx-sm-2"></div>
            </li>
            {/* <!--[ Start:: user detail ]--> */}
            <li className="nav-item user ms-3">
              <a
                className="dropdown-toggle gray-6 d-flex text-decoration-none align-items-center lh-sm p-0"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                title="User"
                data-bs-auto-close="outside"
              ></a>
              <UserDropdown />
            </li>
            <li className="nav-item ms-3">
              <button
                className="btn btn-danger"
                onClick={handleLogout}
                style={{ minWidth: "100px" }}
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      </header>
      <CommonSetting selectedMode={selectedMode} />
    </>
  );
};

export default CommonHeader;
